import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withKeys as _withKeys, vModelSelect as _vModelSelect, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "vf" }
const _hoisted_2 = {
  class: "vf-queues",
  "aria-label": "Files de vérification"
}
const _hoisted_3 = ["aria-pressed", "onClick"]
const _hoisted_4 = {
  class: "vf-card",
  "aria-labelledby": "vf-list-title"
}
const _hoisted_5 = { class: "vf-list-head" }
const _hoisted_6 = { id: "vf-list-title" }
const _hoisted_7 = { class: "vf-count" }
const _hoisted_8 = { class: "vf-search" }
const _hoisted_9 = {
  key: 0,
  class: "vf-error",
  role: "alert"
}
const _hoisted_10 = { class: "vf-table" }
const _hoisted_11 = ["onClick", "onKeydown"]
const _hoisted_12 = { "data-label": "Client" }
const _hoisted_13 = { class: "vf-client" }
const _hoisted_14 = ["src"]
const _hoisted_15 = {
  key: 1,
  class: "vf-avatar vf-avatar--empty"
}
const _hoisted_16 = { "data-label": "Contact" }
const _hoisted_17 = { class: "d-block" }
const _hoisted_18 = { class: "vf-muted" }
const _hoisted_19 = { "data-label": "Pièce d'identité" }
const _hoisted_20 = { "data-label": "Contrat" }
const _hoisted_21 = {
  "data-label": "Soumis",
  class: "text-nowrap"
}
const _hoisted_22 = { class: "d-block" }
const _hoisted_23 = { class: "vf-muted" }
const _hoisted_24 = { class: "vf-cell-action" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = {
  key: 0,
  class: "vf-empty"
}
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { key: 2 }
const _hoisted_30 = {
  key: 0,
  class: "vf-pager"
}
const _hoisted_31 = { class: "vf-muted" }
const _hoisted_32 = { class: "vf-pager-ctrl" }
const _hoisted_33 = ["value"]
const _hoisted_34 = ["disabled"]
const _hoisted_35 = ["disabled"]
const _hoisted_36 = { class: "vf-drawer-head" }
const _hoisted_37 = {
  key: 0,
  class: "vf-client"
}
const _hoisted_38 = ["src"]
const _hoisted_39 = {
  key: 1,
  class: "vf-avatar vf-avatar--lg vf-avatar--empty"
}
const _hoisted_40 = { id: "vf-d-title" }
const _hoisted_41 = { class: "vf-muted" }
const _hoisted_42 = {
  key: 1,
  id: "vf-d-title",
  class: "vf-muted"
}
const _hoisted_43 = {
  key: 0,
  class: "vf-drawer-body"
}
const _hoisted_44 = {
  key: 1,
  class: "vf-drawer-body"
}
const _hoisted_45 = { class: "vf-facts" }
const _hoisted_46 = { class: "vf-mono" }
const _hoisted_47 = { class: "vf-facts-wide" }
const _hoisted_48 = ["aria-labelledby"]
const _hoisted_49 = { class: "vf-doc-head" }
const _hoisted_50 = ["id"]
const _hoisted_51 = {
  key: 0,
  class: "vf-muted vf-doc-none"
}
const _hoisted_52 = { class: "vf-files" }
const _hoisted_53 = ["href"]
const _hoisted_54 = ["src", "alt"]
const _hoisted_55 = {
  key: 1,
  class: "vf-file-pdf"
}
const _hoisted_56 = { class: "vf-file-cap" }
const _hoisted_57 = {
  key: 1,
  class: "vf-file vf-file--missing"
}
const _hoisted_58 = { class: "vf-file-cap" }
const _hoisted_59 = {
  key: 0,
  class: "vf-reason"
}
const _hoisted_60 = {
  key: 1,
  class: "vf-decide"
}
const _hoisted_61 = ["for"]
const _hoisted_62 = {
  class: "vf-chips",
  role: "group",
  "aria-label": "Motifs fréquents"
}
const _hoisted_63 = ["onClick"]
const _hoisted_64 = ["id", "onUpdate:modelValue"]
const _hoisted_65 = { class: "vf-decide-actions" }
const _hoisted_66 = ["disabled", "onClick"]
const _hoisted_67 = ["disabled", "onClick"]
const _hoisted_68 = {
  key: 0,
  class: "spinner-border spinner-border-sm",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_69 = {
  key: 1,
  class: "vf-decide-actions"
}
const _hoisted_70 = ["onClick"]
const _hoisted_71 = ["disabled", "onClick"]
const _hoisted_72 = ["disabled", "title", "onClick"]
const _hoisted_73 = {
  key: 0,
  class: "spinner-border spinner-border-sm",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_74 = {
  key: 1,
  class: "ph ph-check-circle",
  "aria-hidden": "true"
}
const _hoisted_75 = ["onClick"]

import { computed, nextTick, onBeforeUnmount, onMounted, reactive, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import api from "@/utils/axios";
import { useAppToast } from "@/composables/useAppToast";

type DocKey = "cin" | "contrat";
type Queue = "pending" | "rejected" | "verified" | "all";

interface VerificationRow {
  id: number;
  ref: string;
  name: string;
  store_name: string | null;
  logo: string | null;
  cin: string | null;
  phone: string | null;
  email: string | null;
  address: string | null;
  city_name: string | null;
  ask_cin_verified: number;
  cin_verified: number;
  raison_cin_verified: string | null;
  cin_recto: string | null;
  cin_verso: string | null;
  ask_cntr_verified: number;
  contrat_verified: number;
  raison_cntr_verified: string | null;
  contrat_file: string | null;
  verification_time: string | null;
  [key: string]: any;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'VerificationList',
  setup(__props) {

const { showToast } = useAppToast();
const route = useRoute();
const router = useRouter();

const queues: { key: Queue; label: string; icon: string; tone: string }[] = [
  { key: "pending", label: "À examiner", icon: "ph ph-hourglass-medium", tone: "info" },
  { key: "rejected", label: "Refusés", icon: "ph ph-x-circle", tone: "danger" },
  { key: "verified", label: "Vérifiés", icon: "ph ph-seal-check", tone: "success" },
  { key: "all", label: "Tous", icon: "ph ph-list-bullets", tone: "neutral" },
];

const docSections = [
  {
    key: "cin" as DocKey,
    title: "Pièce d'identité (CIN)",
    icon: "ph ph-identification-card",
    ask: "ask_cin_verified",
    status: "cin_verified",
    reason: "raison_cin_verified",
    files: [
      { field: "cin_recto", label: "Recto" },
      { field: "cin_verso", label: "Verso" },
    ],
    reasons: ["Document illisible ou flou", "CIN expirée", "Le nom ne correspond pas au compte", "Recto ou verso manquant"],
  },
  {
    key: "contrat" as DocKey,
    title: "Contrat de service",
    icon: "ph ph-file-text",
    ask: "ask_cntr_verified",
    status: "contrat_verified",
    reason: "raison_cntr_verified",
    files: [{ field: "contrat_file", label: "Contrat signé" }],
    reasons: ["Contrat non signé", "Pages manquantes", "Document illisible", "Cachet de la société manquant"],
  },
];

const rows = ref<VerificationRow[]>([]);
const counts = ref<Partial<Record<Queue, number>>>({});
const loading = ref(false);
const loadError = ref(false);
const filters = reactive({ queue: "pending" as Queue, search: "", per_page: 15 });
const pager = reactive({ current_page: 1, last_page: 1, total: 0, from: 0, to: 0 });

const currentQueue = computed(() => queues.find((q) => q.key === filters.queue) || queues[0]);

let reqId = 0;
async function load(page = pager.current_page) {
  const id = ++reqId;
  loading.value = true;
  loadError.value = false;
  try {
    const { data } = await api.get("/api/auth/verifications", {
      params: { queue: filters.queue, searchTerm: filters.search.trim(), page, per_page: filters.per_page },
    });
    if (id !== reqId) return; // a newer request superseded this one
    rows.value = data.users.data;
    Object.assign(pager, {
      current_page: data.users.current_page,
      last_page: data.users.last_page,
      total: data.users.total,
      from: data.users.from,
      to: data.users.to,
    });
    counts.value = data.counts || {};
  } catch (e) {
    if (id === reqId) loadError.value = true;
  } finally {
    if (id === reqId) loading.value = false;
  }
}

let searchTimer: ReturnType<typeof setTimeout> | undefined;
function debouncedLoad() {
  clearTimeout(searchTimer);
  searchTimer = setTimeout(() => load(1), 350);
}

function setQueue(q: Queue) {
  if (filters.queue === q) return;
  filters.queue = q;
  load(1);
}

/* ── Document status ─────────────────────────────────────── */
function docState(r: VerificationRow, doc: DocKey) {
  const asked = doc === "cin" ? r.ask_cin_verified : r.ask_cntr_verified;
  const status = doc === "cin" ? r.cin_verified : r.contrat_verified;
  if (!Number(asked)) return { label: "Non envoyé", tone: "neutral", icon: "ph ph-minus-circle" };
  if (Number(status) === 1) return { label: "Approuvé", tone: "success", icon: "ph ph-check-circle" };
  if (Number(status) === 2) return { label: "Refusé", tone: "danger", icon: "ph ph-x-circle" };
  return { label: "À examiner", tone: "info", icon: "ph ph-hourglass-medium" };
}
const needsReview = (r: VerificationRow) =>
  (Number(r.ask_cin_verified) && Number(r.cin_verified) === 0) ||
  (Number(r.ask_cntr_verified) && Number(r.contrat_verified) === 0);
const hasFiles = (r: VerificationRow, doc: (typeof docSections)[number]) => doc.files.every((f) => !!r[f.field]);

/* ── Drawer ──────────────────────────────────────────────── */
const detail = ref<VerificationRow | null>(null);
const detailLoading = ref(false);
const drawerEl = ref<HTMLElement | null>(null);
const saving = ref<DocKey | "">("");
const rejecting = reactive<Record<DocKey, boolean>>({ cin: false, contrat: false });
const editing = reactive<Record<DocKey, boolean>>({ cin: false, contrat: false });
const reasons = reactive<Record<DocKey, string>>({ cin: "", contrat: "" });
let lastFocus: HTMLElement | null = null;

function resetDecision() {
  (["cin", "contrat"] as DocKey[]).forEach((k) => {
    rejecting[k] = false;
    editing[k] = false;
    reasons[k] = "";
  });
}

async function openDetail(id: number) {
  if (!detail.value && !detailLoading.value) lastFocus = document.activeElement as HTMLElement;
  resetDecision();
  detailLoading.value = true;
  try {
    const { data } = await api.get(`/api/auth/verifications/show/${id}`);
    detail.value = data.customer;
    if (route.query.open != String(id)) router.replace({ query: { ...route.query, open: String(id) } });
    await nextTick();
    drawerEl.value?.focus();
  } catch (e: any) {
    showToast(e?.response?.data?.message || "Impossible d'ouvrir ce dossier", "error");
    closeDetail();
  } finally {
    detailLoading.value = false;
  }
}

function closeDetail() {
  detail.value = null;
  detailLoading.value = false;
  if (route.query.open) {
    const { open, ...rest } = route.query;
    router.replace({ query: rest });
  }
  lastFocus?.focus?.();
}

function startReject(doc: DocKey) {
  rejecting[doc] = true;
  reasons[doc] = "";
  nextTick(() => document.getElementById("vf-reason-" + doc)?.focus());
}

async function decide(doc: DocKey, statut: 1 | 2) {
  if (!detail.value) return;
  const id = detail.value.id;
  saving.value = doc;
  try {
    const url = doc === "cin" ? `/api/auth/verifications/active-cin/${id}` : `/api/auth/verifications/active-contrat/${id}`;
    const { data } = await api.post(url, { statut, raison: statut === 2 ? reasons[doc].trim() : null });
    if (!data.success) throw { response: { data } };
    showToast(data.message, "success");
    rejecting[doc] = false;
    editing[doc] = false;
    // refresh the drawer and the list (the row may leave the current queue)
    const [{ data: fresh }] = await Promise.all([api.get(`/api/auth/verifications/show/${id}`), load()]);
    detail.value = fresh.customer;
  } catch (e: any) {
    const err = e?.response?.data;
    const first = err?.errors ? (Object.values(err.errors)[0] as string[])[0] : null;
    showToast(first || err?.message || "Erreur serveur, veuillez réessayer", "error");
  } finally {
    saving.value = "";
  }
}

/* ── Formatting ──────────────────────────────────────────── */
const isPdf = (url: string) => /\.pdf($|[?#])/i.test(url || "");
const initials = (name: string) =>
  (name || "?").split(/\s+/).filter(Boolean).slice(0, 2).map((w) => w[0].toUpperCase()).join("");
const toDate = (v: string | null) => (v ? new Date(String(v).replace(" ", "T")) : null);
const dateOnly = (v: string | null) => toDate(v)?.toLocaleDateString("fr-FR", { day: "2-digit", month: "short", year: "numeric" }) || "—";
const dateTime = (v: string | null) =>
  toDate(v)?.toLocaleString("fr-FR", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }) || "—";
function ago(v: string | null) {
  const d = toDate(v);
  if (!d) return "";
  const mins = Math.max(0, Math.round((Date.now() - d.getTime()) / 60000));
  if (mins < 60) return `il y a ${mins} min`;
  const h = Math.round(mins / 60);
  if (h < 24) return `il y a ${h} h`;
  const days = Math.round(h / 24);
  return days < 31 ? `il y a ${days} j` : `il y a ${Math.round(days / 30)} mois`;
}

onMounted(async () => {
  await load(1);
  if (route.query.open) openDetail(Number(route.query.open));
});
// the header alert links to ?open=<id>, also while this page is already displayed
watch(
  () => route.query.open,
  (open) => {
    if (open && Number(open) !== detail.value?.id && !detailLoading.value) openDetail(Number(open));
  }
);
onBeforeUnmount(() => clearTimeout(searchTimer));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[31] || (_cache[31] = _createElementVNode("header", { class: "vf-head" }, [
      _createElementVNode("span", { class: "vf-eyebrow" }, "Clients"),
      _createElementVNode("h1", { class: "vf-title" }, "Centre de vérification"),
      _createElementVNode("p", { class: "vf-sub" }, "Contrôlez la pièce d'identité et le contrat signé de chaque client. Le client est notifié de chaque décision.")
    ], -1)),
    _createElementVNode("nav", _hoisted_2, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(queues, (q) => {
        return _createElementVNode("button", {
          key: q.key,
          type: "button",
          class: _normalizeClass(['vf-queue', 'tone-' + q.tone, { 'is-active': filters.queue === q.key }]),
          "aria-pressed": filters.queue === q.key,
          onClick: ($event: any) => (setQueue(q.key))
        }, [
          _createElementVNode("i", {
            class: _normalizeClass(q.icon),
            "aria-hidden": "true"
          }, null, 2),
          _createElementVNode("span", null, _toDisplayString(q.label), 1),
          _createElementVNode("b", null, _toDisplayString(counts.value[q.key] ?? 0), 1)
        ], 10, _hoisted_3)
      }), 64))
    ]),
    _createElementVNode("section", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("h2", _hoisted_6, [
          _createTextVNode(_toDisplayString(currentQueue.value.label) + " ", 1),
          _createElementVNode("span", _hoisted_7, _toDisplayString(pager.total), 1)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _cache[6] || (_cache[6] = _createElementVNode("i", {
            class: "ph ph-magnifying-glass",
            "aria-hidden": "true"
          }, null, -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filters.search) = $event)),
            type: "search",
            placeholder: "Client, magasin, email, téléphone, CIN…",
            "aria-label": "Rechercher un client",
            onInput: debouncedLoad
          }, null, 544), [
            [_vModelText, filters.search]
          ])
        ])
      ]),
      (loadError.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _cache[7] || (_cache[7] = _createElementVNode("i", {
              class: "ph ph-warning-circle",
              "aria-hidden": "true"
            }, null, -1)),
            _cache[8] || (_cache[8] = _createTextVNode(" Impossible de charger les vérifications. ", -1)),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-sm btn-light",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (load()))
            }, "Réessayer")
          ]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", {
              class: _normalizeClass(["vf-table-wrap", { 'is-loading': loading.value }])
            }, [
              _createElementVNode("table", _hoisted_10, [
                _cache[11] || (_cache[11] = _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", { scope: "col" }, "Client"),
                    _createElementVNode("th", { scope: "col" }, "Contact"),
                    _createElementVNode("th", { scope: "col" }, "Pièce d'identité"),
                    _createElementVNode("th", { scope: "col" }, "Contrat"),
                    _createElementVNode("th", { scope: "col" }, "Soumis"),
                    _createElementVNode("th", { scope: "col" }, [
                      _createElementVNode("span", { class: "visually-hidden" }, "Action")
                    ])
                  ])
                ], -1)),
                _createElementVNode("tbody", null, [
                  (loading.value && !rows.value.length)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(5, (n) => {
                        return _createElementVNode("tr", {
                          key: 's' + n,
                          class: "vf-skel-row"
                        }, _cache[9] || (_cache[9] = [
                          _createElementVNode("td", { colspan: "6" }, [
                            _createElementVNode("span", { class: "vf-skel" })
                          ], -1)
                        ]))
                      }), 64))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rows.value, (r) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: r.id,
                      class: _normalizeClass({ 'is-open': detail.value?.id === r.id }),
                      tabindex: "0",
                      onClick: ($event: any) => (openDetail(r.id)),
                      onKeydown: _withKeys(_withModifiers(($event: any) => (openDetail(r.id)), ["prevent"]), ["enter"])
                    }, [
                      _createElementVNode("td", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                          (r.logo)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: r.logo,
                                alt: "",
                                class: "vf-avatar",
                                loading: "lazy"
                              }, null, 8, _hoisted_14))
                            : (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(initials(r.name)), 1)),
                          _createElementVNode("div", null, [
                            _createElementVNode("strong", null, _toDisplayString(r.store_name || r.name), 1),
                            _createElementVNode("small", null, _toDisplayString(r.store_name ? r.name + " · " : "") + _toDisplayString(r.ref), 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_16, [
                        _createElementVNode("span", _hoisted_17, _toDisplayString(r.phone || "—"), 1),
                        _createElementVNode("small", _hoisted_18, _toDisplayString(r.email), 1)
                      ]),
                      _createElementVNode("td", _hoisted_19, [
                        _createElementVNode("span", {
                          class: _normalizeClass(['vf-badge', 'tone-' + docState(r, 'cin').tone])
                        }, [
                          _createElementVNode("i", {
                            class: _normalizeClass(docState(r, 'cin').icon),
                            "aria-hidden": "true"
                          }, null, 2),
                          _createTextVNode(_toDisplayString(docState(r, "cin").label), 1)
                        ], 2)
                      ]),
                      _createElementVNode("td", _hoisted_20, [
                        _createElementVNode("span", {
                          class: _normalizeClass(['vf-badge', 'tone-' + docState(r, 'contrat').tone])
                        }, [
                          _createElementVNode("i", {
                            class: _normalizeClass(docState(r, 'contrat').icon),
                            "aria-hidden": "true"
                          }, null, 2),
                          _createTextVNode(_toDisplayString(docState(r, "contrat").label), 1)
                        ], 2)
                      ]),
                      _createElementVNode("td", _hoisted_21, [
                        _createElementVNode("span", _hoisted_22, _toDisplayString(dateOnly(r.verification_time)), 1),
                        _createElementVNode("small", _hoisted_23, _toDisplayString(ago(r.verification_time)), 1)
                      ]),
                      _createElementVNode("td", _hoisted_24, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "vf-review-btn",
                          onClick: _withModifiers(($event: any) => (openDetail(r.id)), ["stop"])
                        }, [
                          _createTextVNode(_toDisplayString(needsReview(r) ? "Examiner" : "Voir") + " ", 1),
                          _cache[10] || (_cache[10] = _createElementVNode("i", {
                            class: "ph ph-caret-right",
                            "aria-hidden": "true"
                          }, null, -1))
                        ], 8, _hoisted_25)
                      ])
                    ], 42, _hoisted_11))
                  }), 128))
                ])
              ]),
              (!loading.value && !rows.value.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                    _createElementVNode("i", {
                      class: _normalizeClass(filters.search ? 'ph ph-magnifying-glass' : 'ph ph-shield-check'),
                      "aria-hidden": "true"
                    }, null, 2),
                    (filters.search)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_27, "Aucun client ne correspond à « " + _toDisplayString(filters.search) + " ».", 1))
                      : (filters.queue === 'pending')
                        ? (_openBlock(), _createElementBlock("p", _hoisted_28, "Tout est à jour : aucun document en attente."))
                        : (_openBlock(), _createElementBlock("p", _hoisted_29, "Aucun client dans cette file."))
                  ]))
                : _createCommentVNode("", true)
            ], 2),
            (pager.last_page > 1 || pager.total > 15)
              ? (_openBlock(), _createElementBlock("footer", _hoisted_30, [
                  _createElementVNode("span", _hoisted_31, _toDisplayString(pager.from || 0) + "–" + _toDisplayString(pager.to || 0) + " sur " + _toDisplayString(pager.total), 1),
                  _createElementVNode("div", _hoisted_32, [
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filters.per_page) = $event)),
                      class: "form-select form-select-sm",
                      "aria-label": "Lignes par page",
                      onChange: _cache[3] || (_cache[3] = ($event: any) => (load(1)))
                    }, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList([15, 30, 50], (n) => {
                        return _createElementVNode("option", {
                          key: n,
                          value: n
                        }, _toDisplayString(n) + " / page", 9, _hoisted_33)
                      }), 64))
                    ], 544), [
                      [
                        _vModelSelect,
                        filters.per_page,
                        void 0,
                        { number: true }
                      ]
                    ]),
                    _createElementVNode("button", {
                      type: "button",
                      class: "vf-icon-btn",
                      disabled: pager.current_page <= 1,
                      "aria-label": "Page précédente",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (load(pager.current_page - 1)))
                    }, _cache[12] || (_cache[12] = [
                      _createElementVNode("i", {
                        class: "ph ph-caret-left",
                        "aria-hidden": "true"
                      }, null, -1)
                    ]), 8, _hoisted_34),
                    _createElementVNode("span", null, _toDisplayString(pager.current_page) + " / " + _toDisplayString(pager.last_page), 1),
                    _createElementVNode("button", {
                      type: "button",
                      class: "vf-icon-btn",
                      disabled: pager.current_page >= pager.last_page,
                      "aria-label": "Page suivante",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (load(pager.current_page + 1)))
                    }, _cache[13] || (_cache[13] = [
                      _createElementVNode("i", {
                        class: "ph ph-caret-right",
                        "aria-hidden": "true"
                      }, null, -1)
                    ]), 8, _hoisted_35)
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 64))
    ]),
    _createVNode(_Transition, { name: "vf-fade" }, {
      default: _withCtx(() => [
        (detail.value || detailLoading.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "vf-scrim",
              onClick: closeDetail
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "vf-slide" }, {
      default: _withCtx(() => [
        (detail.value || detailLoading.value)
          ? (_openBlock(), _createElementBlock("aside", {
              key: 0,
              ref_key: "drawerEl",
              ref: drawerEl,
              class: "vf-drawer",
              role: "dialog",
              "aria-modal": "true",
              "aria-labelledby": "vf-d-title",
              tabindex: "-1",
              onKeydown: _withKeys(closeDetail, ["esc"])
            }, [
              _createElementVNode("header", _hoisted_36, [
                (detail.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                      (detail.value.logo)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: detail.value.logo,
                            alt: "",
                            class: "vf-avatar vf-avatar--lg"
                          }, null, 8, _hoisted_38))
                        : (_openBlock(), _createElementBlock("span", _hoisted_39, _toDisplayString(initials(detail.value.name)), 1)),
                      _createElementVNode("div", null, [
                        _cache[14] || (_cache[14] = _createElementVNode("span", { class: "vf-eyebrow" }, "Vérification", -1)),
                        _createElementVNode("h2", _hoisted_40, _toDisplayString(detail.value.store_name || detail.value.name), 1),
                        _createElementVNode("small", _hoisted_41, _toDisplayString(detail.value.ref) + " · soumis le " + _toDisplayString(dateTime(detail.value.verification_time)), 1)
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("h2", _hoisted_42, "Chargement…")),
                _createElementVNode("button", {
                  type: "button",
                  class: "vf-icon-btn",
                  "aria-label": "Fermer",
                  onClick: closeDetail
                }, _cache[15] || (_cache[15] = [
                  _createElementVNode("i", {
                    class: "ph ph-x",
                    "aria-hidden": "true"
                  }, null, -1)
                ]))
              ]),
              (detailLoading.value && !detail.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (n) => {
                      return _createElementVNode("span", {
                        key: n,
                        class: "vf-skel vf-skel--block"
                      })
                    }), 64))
                  ]))
                : (detail.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                      _createElementVNode("dl", _hoisted_45, [
                        _createElementVNode("div", null, [
                          _cache[16] || (_cache[16] = _createElementVNode("dt", null, "Nom", -1)),
                          _createElementVNode("dd", null, _toDisplayString(detail.value.name || "—"), 1)
                        ]),
                        _createElementVNode("div", null, [
                          _cache[17] || (_cache[17] = _createElementVNode("dt", null, "N° CIN déclaré", -1)),
                          _createElementVNode("dd", _hoisted_46, _toDisplayString(detail.value.cin || "—"), 1)
                        ]),
                        _createElementVNode("div", null, [
                          _cache[18] || (_cache[18] = _createElementVNode("dt", null, "Téléphone", -1)),
                          _createElementVNode("dd", null, _toDisplayString(detail.value.phone || "—"), 1)
                        ]),
                        _createElementVNode("div", null, [
                          _cache[19] || (_cache[19] = _createElementVNode("dt", null, "Email", -1)),
                          _createElementVNode("dd", null, _toDisplayString(detail.value.email || "—"), 1)
                        ]),
                        _createElementVNode("div", _hoisted_47, [
                          _cache[20] || (_cache[20] = _createElementVNode("dt", null, "Adresse", -1)),
                          _createElementVNode("dd", null, _toDisplayString([detail.value.address, detail.value.city_name].filter(Boolean).join(", ") || "—"), 1)
                        ])
                      ]),
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(docSections, (doc) => {
                        return _createElementVNode("section", {
                          key: doc.key,
                          class: "vf-doc",
                          "aria-labelledby": 'vf-doc-' + doc.key
                        }, [
                          _createElementVNode("div", _hoisted_49, [
                            _createElementVNode("h3", {
                              id: 'vf-doc-' + doc.key
                            }, [
                              _createElementVNode("i", {
                                class: _normalizeClass(doc.icon),
                                "aria-hidden": "true"
                              }, null, 2),
                              _createTextVNode(_toDisplayString(doc.title), 1)
                            ], 8, _hoisted_50),
                            _createElementVNode("span", {
                              class: _normalizeClass(['vf-badge', 'tone-' + docState(detail.value, doc.key).tone])
                            }, [
                              _createElementVNode("i", {
                                class: _normalizeClass(docState(detail.value, doc.key).icon),
                                "aria-hidden": "true"
                              }, null, 2),
                              _createTextVNode(_toDisplayString(docState(detail.value, doc.key).label), 1)
                            ], 2)
                          ]),
                          (!detail.value[doc.ask])
                            ? (_openBlock(), _createElementBlock("p", _hoisted_51, "Le client n'a pas encore envoyé ce document."))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createElementVNode("div", _hoisted_52, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(doc.files, (f) => {
                                    return (_openBlock(), _createElementBlock(_Fragment, {
                                      key: f.field
                                    }, [
                                      (detail.value[f.field])
                                        ? (_openBlock(), _createElementBlock("a", {
                                            key: 0,
                                            href: detail.value[f.field],
                                            target: "_blank",
                                            rel: "noopener",
                                            class: "vf-file"
                                          }, [
                                            (!isPdf(detail.value[f.field]))
                                              ? (_openBlock(), _createElementBlock("img", {
                                                  key: 0,
                                                  src: detail.value[f.field],
                                                  alt: f.label,
                                                  loading: "lazy"
                                                }, null, 8, _hoisted_54))
                                              : (_openBlock(), _createElementBlock("span", _hoisted_55, _cache[21] || (_cache[21] = [
                                                  _createElementVNode("i", {
                                                    class: "ph ph-file-pdf",
                                                    "aria-hidden": "true"
                                                  }, null, -1),
                                                  _createTextVNode("PDF", -1)
                                                ]))),
                                            _createElementVNode("span", _hoisted_56, [
                                              _createTextVNode(_toDisplayString(f.label) + " ", 1),
                                              _cache[22] || (_cache[22] = _createElementVNode("i", {
                                                class: "ph ph-arrow-square-out",
                                                "aria-hidden": "true"
                                              }, null, -1))
                                            ])
                                          ], 8, _hoisted_53))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_57, [
                                            _cache[23] || (_cache[23] = _createElementVNode("span", { class: "vf-file-pdf" }, [
                                              _createElementVNode("i", {
                                                class: "ph ph-file-x",
                                                "aria-hidden": "true"
                                              }),
                                              _createTextVNode("Fichier manquant")
                                            ], -1)),
                                            _createElementVNode("span", _hoisted_58, _toDisplayString(f.label), 1)
                                          ]))
                                    ], 64))
                                  }), 128))
                                ]),
                                (detail.value[doc.status] === 2 && detail.value[doc.reason])
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_59, [
                                      _cache[25] || (_cache[25] = _createElementVNode("i", {
                                        class: "ph ph-chat-circle-text",
                                        "aria-hidden": "true"
                                      }, null, -1)),
                                      _createElementVNode("span", null, [
                                        _cache[24] || (_cache[24] = _createElementVNode("b", null, "Motif du refus :", -1)),
                                        _createTextVNode(" " + _toDisplayString(detail.value[doc.reason]), 1)
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (detail.value[doc.status] === 0 || editing[doc.key])
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                                      (rejecting[doc.key])
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _createElementVNode("label", {
                                              for: 'vf-reason-' + doc.key,
                                              class: "vf-label"
                                            }, _cache[26] || (_cache[26] = [
                                              _createTextVNode("Motif du refus ", -1),
                                              _createElementVNode("span", { class: "text-danger" }, "*", -1)
                                            ]), 8, _hoisted_61),
                                            _createElementVNode("div", _hoisted_62, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(doc.reasons, (m) => {
                                                return (_openBlock(), _createElementBlock("button", {
                                                  key: m,
                                                  type: "button",
                                                  class: "vf-chip",
                                                  onClick: ($event: any) => (reasons[doc.key] = m)
                                                }, _toDisplayString(m), 9, _hoisted_63))
                                              }), 128))
                                            ]),
                                            _withDirectives(_createElementVNode("textarea", {
                                              id: 'vf-reason-' + doc.key,
                                              "onUpdate:modelValue": ($event: any) => ((reasons[doc.key]) = $event),
                                              class: "form-control",
                                              rows: "3",
                                              maxlength: "500",
                                              placeholder: "Expliquez au client ce qu'il doit corriger"
                                            }, null, 8, _hoisted_64), [
                                              [_vModelText, reasons[doc.key]]
                                            ]),
                                            _createElementVNode("div", _hoisted_65, [
                                              _createElementVNode("button", {
                                                type: "button",
                                                class: "btn btn-light",
                                                disabled: saving.value === doc.key,
                                                onClick: ($event: any) => (rejecting[doc.key] = false)
                                              }, "Annuler", 8, _hoisted_66),
                                              _createElementVNode("button", {
                                                type: "button",
                                                class: "btn btn-danger",
                                                disabled: saving.value === doc.key || !reasons[doc.key]?.trim(),
                                                onClick: ($event: any) => (decide(doc.key, 2))
                                              }, [
                                                (saving.value === doc.key)
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_68))
                                                  : _createCommentVNode("", true),
                                                _cache[27] || (_cache[27] = _createTextVNode(" Confirmer le refus ", -1))
                                              ], 8, _hoisted_67)
                                            ])
                                          ], 64))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_69, [
                                            (editing[doc.key])
                                              ? (_openBlock(), _createElementBlock("button", {
                                                  key: 0,
                                                  type: "button",
                                                  class: "btn btn-light me-auto",
                                                  onClick: ($event: any) => (editing[doc.key] = false)
                                                }, "Annuler", 8, _hoisted_70))
                                              : _createCommentVNode("", true),
                                            _createElementVNode("button", {
                                              type: "button",
                                              class: "btn btn-outline-danger",
                                              disabled: !!saving.value,
                                              onClick: ($event: any) => (startReject(doc.key))
                                            }, _cache[28] || (_cache[28] = [
                                              _createElementVNode("i", {
                                                class: "ph ph-x-circle",
                                                "aria-hidden": "true"
                                              }, null, -1),
                                              _createTextVNode(" Refuser ", -1)
                                            ]), 8, _hoisted_71),
                                            _createElementVNode("button", {
                                              type: "button",
                                              class: "btn btn-success",
                                              disabled: !!saving.value || !hasFiles(detail.value, doc),
                                              title: hasFiles(detail.value, doc) ? '' : 'Fichier manquant : refusez pour demander un nouvel envoi',
                                              onClick: ($event: any) => (decide(doc.key, 1))
                                            }, [
                                              (saving.value === doc.key)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_73))
                                                : (_openBlock(), _createElementBlock("i", _hoisted_74)),
                                              _cache[29] || (_cache[29] = _createTextVNode(" Approuver ", -1))
                                            ], 8, _hoisted_72)
                                          ]))
                                    ]))
                                  : (_openBlock(), _createElementBlock("button", {
                                      key: 2,
                                      type: "button",
                                      class: "vf-link",
                                      onClick: ($event: any) => (editing[doc.key] = true)
                                    }, _cache[30] || (_cache[30] = [
                                      _createElementVNode("i", {
                                        class: "ph ph-pencil-simple",
                                        "aria-hidden": "true"
                                      }, null, -1),
                                      _createTextVNode(" Modifier la décision ", -1)
                                    ]), 8, _hoisted_75))
                              ], 64))
                        ], 8, _hoisted_48)
                      }), 64))
                    ]))
                  : _createCommentVNode("", true)
            ], 544))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})